import React from 'react'

class MediaItem extends React.Component {
    onClickItem () {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }
    render() {
        const { content } = this.props
        return (
            <div className="wk-media-item" onClick={e => this.onClickItem()}>
                <div className="item-left">
                    <div className="cover" style={{backgroundImage: `url(${content.cover})`}}>
                    </div>
                </div>
                <div className="item-right">
                    <div className="top">
                        {content.topText}
                    </div>
                    <div className="middle">
                        {content.middleText}
                    </div>
                    {
                        content.bottomText ? <div className="bottom">
                            {content.bottomText}
                        </div> : <div className="bottom" dangerouslySetInnerHTML={{__html: content.bottomHtml}}>
                        </div>
                    }
                </div>
                <div className="fixed">
                    {content.fixed}
                </div>
            </div>
        )
    }
}

export default MediaItem


// WEBPACK FOOTER //
// ./src/pages/resell/MediaItem.js